export default __webpack_public_path__ + "static/0263-e4e3eec0d89e7457691772b358eb42a8.png";